export const META_DESCRIPTION_MAX_LENGTH = 150
